import { Pagamento } from "src/components/pagamento/Pagamento";
import { pageTitle$ } from "src/framework/store";
import "./style.css";

const Home = () => {
  pageTitle$.next("")

  return (
    <div className="container-pagamento container">
      <div className="row row-pagamento">
        <div className="X12 grid-funil-projetos">
          <Pagamento />
        </div>
      </div>
    </div>
  );
};

export { Home };
